import React, { Component } from 'react';
import { CheckBox } from 'devextreme-react/check-box';
import Button from 'devextreme-react/button';
import '@fortawesome/fontawesome-free/css/all.min.css';
import notify from 'devextreme/ui/notify';
import styles from './SignersList.module.css'
import VerifyPopup from "../../components/verifyPopup/VerifyPopup"

const { REACT_APP_SERVER_URL } = process.env;

class SignersList extends Component {
  constructor(props) {
    super(props);
    this.signerButtonText = "";
    this.isSigningButtonDisabled = true;
    this.isReminderButtonDisabled = false;
    this.isDownloadButtonDisabled = true;
    this.isCRMButtonDisabled = true;
    this.currentSignerFlag = false;
    this.state = {
      blockedSignerIndex: null,
      isUnlocking: false
    }
  }

  // This lifecycle method runs whenever props or state change.
  componentDidUpdate(prevProps) {
    // Check if the blocking prop has actually changed to prevent infinite loops.
    if (this.props.isNextSignerBlocked !== prevProps.isNextSignerBlocked) {
      if (this.props.isNextSignerBlocked) {
        // If blocking is now active, find the index of the first un-signed signer and update the state.
        const firstUnsignedSignerIndex = this.props.signersDetails?.findIndex(
          signer => signer.name && !signer.name.includes("CoSign") && !signer.is_completed
        );

        // Only update the state if a relevant signer was found (findIndex doesn't return -1).
        if (firstUnsignedSignerIndex !== -1) {
          this.setState({ blockedSignerIndex: firstUnsignedSignerIndex });
        }
      } else {
        // If blocking was deactivated, reset the index in the state.
        this.setState({ blockedSignerIndex: null });
      }
    }
  }

  signOrSigned = (signerSigningStatus) => {
    this.isSigningButtonDisabled = true;
    if (signerSigningStatus === false) {
      this.signerButtonText = "לחץ לחתימה";
      if (this.currentSignerFlag === true) {
        this.isSigningButtonDisabled = false;
        this.isReminderButtonDisabled = false;
        this.currentSignerFlag = false;
      }

    }
    else if (signerSigningStatus == true) {
      this.signerButtonText = "נחתם";
    }

    else {
      this.signerButtonText = "לחץ לחתימה";

    }
  }

  handleClick = (signingLink) => {
    window.open(signingLink, '_blank')
  };



  downloadFile = (attachmentLink) => {
    // Create a temporary anchor element
    const anchor = document.createElement('a');
    anchor.href = attachmentLink;

    // Set the download attribute to force download
    anchor.setAttribute('download', '');

    // Programmatically trigger a click event on the anchor element
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }


  sendSigningReminder = () => {
    if (!this.props.task_id || !this.props.document_id)
      return null;

    const requestURL = `${this.props.REACT_APP_SERVER_URL}SendReminder?task_id=${this.props.task_id}&documentId=${this.props.document_id}`;

    fetch(requestURL, {
      method: "GET",
      credentials: "include",
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
      })
      .then(data => {
        notify('נשלחה תזכורת לחתימה', 'success', 3000);
      })
      .catch(error => {
        notify(`תקלה בשליחת תזכורת: ${error.message}`, 'error', 2000);
      });
  }


  checkButtonSatus = () => {
    if (!this.props.task_id || !this.props.document_id)
      this.isReminderButtonDisabled = true;

    if (!this.props.task_id)
      this.isCRMButtonDisabled = true;
    else
      this.isCRMButtonDisabled = false;

    if (!this.props.attachmentLink)
      this.isDownloadButtonDisabled = true;
    else
      this.isDownloadButtonDisabled = false;
  }

  filterCleints = () => {
    return this.props.signersDetails.filter
  }

  handleReleaseBlock = () => {
    //prevent multiple clicks on signer unlock button
    if (this.state.isUnlocking) {
      return;
    }

    this.setState({ isUnlocking: true });

    if (!this.props.task_id || !this.props.document_id) {
      console.error("Task ID or Document ID is missing.");
      this.setState({ isUnlocking: false });
      return;
    }

    const requestURL = `${this.props.REACT_APP_SERVER_URL}SignerUnlock?taskId=${this.props.task_id}&docId=${this.props.document_id}`;

    fetch(requestURL, {
      method: 'POST',
      credentials: 'include',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`שגיאה בשרת. קוד: ${response.status}`);
        }
        notify("החסימה שוחררה בהצלחה", "success");
        this.props.refreshData();

        return response.text();
      })
      .catch(error => {
        console.error("Failed to release block:", error);
        notify("שגיאה בשחרור החסימה", "error");
      })
      .finally(() => {
        this.setState({ isUnlocking: false });
      });
  };

  createSignersList = () => {
    this.currentSignerFlag = true;
    this.isReminderButtonDisabled = false;

    const isAnySignerBlocked = this.props.isNextSignerBlocked;

    const signersList = this.props.signersDetails?.map((signer, index) => {
      if (signer.name && !signer.name.includes("CoSign")) {
        return (
          <div key={index} className={styles.buttonAndCheckboxDiv}>
            <p>
              <b>{signer.display_name}</b>
            </p>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Button
                icon="fas fa-pen"
                text={signer.is_completed === true ? "נחתם" : "חתום"}
                onClick={() => this.handleClick(signer.url)}
                style={{
                  margin: '5px 0',
                  width: '135px'
                }}
                disabled={!signer.indexInSession}
              />

              <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '30px', marginTop: '4px' }}>
                {signer.indexInSession && (
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      navigator.clipboard.writeText(signer.url)
                        .then(() => notify("📋 הקישור הועתק", 'success', 2000))
                        .catch((err) => notify("שגיאה בהעתקה", 'error', 2000));
                    }}
                    style={{
                      color: '#007bff',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      fontSize: '0.9rem'
                    }}
                    title="העתקת קישור לחתימה"
                  >
                    <i className="fas fa-copy" />
                    העתק קישור
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      } else {
        return null;
      }
    });

    return (
      <>
        {isAnySignerBlocked && (
          <div className={styles.releaseContainer}>
            <span style={{ color: 'red', fontSize: '0.9rem', display: 'block', marginBottom: '5px' }}>
              🔒 זוהה חותם חסום
            </span>
            <Button
              text={this.state.isUnlocking ? "משחרר..." : "לחץ לשחרור"}
              onClick={this.handleReleaseBlock}
              disabled={this.state.isUnlocking}
              style={{
                backgroundColor: this.state.isUnlocking ? '#6c757d' : '#dc3545',
                color: 'white',
                fontWeight: 'bold',
                border: 'none',
                opacity: this.state.isUnlocking ? 0.6 : 1, // אופציונלי - לעמעום כפתור
              }}
              title="שחרור חסימת החותם"
            />
          </div>
        )}
        {signersList}
      </>
    );
  }

  changeStatusToIrrelevant = async () => {

    try {
      const formData = new FormData();
      formData.append("comment", "Empty body");

      notify('מעבד תגובה', 'info', 3000);
      // resetPopup();

      const requestURL = `${REACT_APP_SERVER_URL}CommentOnSubtasks?task_id=${this.props.task_id}&function=change_status`;

      await fetch(requestURL, {
        method: "POST",
        credentials: "include",
        body: formData, // Send formData as the request body
        // Headers are not manually set for multipart/form-data; the browser will set it
      })
        .then((response) => response.json())
        .then((response) => {
          if (response) {
            // props.refreshData();
            notify(`המסמך נמחק בהצלחה!`, 'info', 3000);
            // setGetAgentTasksFlag(!getAgentTasksFlag);
          } else {
            notify(`תקלה בשינוי סטטוס למשימה`, 'error', 3000);
          }
          return response;
        })
        .catch((error) => {
          notify(`תקלה בשינוי סטטוס למשימה : ${error.message}`, 'error', 3000);

        });
    }
    catch (error) {
      notify(`תקלה בשינוי סטטוס למשימה : ${error.message}`, 'error', 3000);

    }
  }



  render() {
    return (
      <div>
        <div className={"content-block dx-card responsive-paddings responsive-paddings signers"} style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }} >
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', flexWrap: 'wrap' }}
          >
            {this.checkButtonSatus()}
            <Button
              text={"שלח תזכורת לחותם הבא"}
              icon="fa fa-clock"
              onClick={() => { this.sendSigningReminder() }}
              disabled={this.isReminderButtonDisabled}
              style={{
                marginBottom: '5px'
              }}
            />
            <Button
              text={"מעבר לקליקאפ"}
              icon="fas fa-external-link-alt"
              onClick={() => { this.handleClick("https://app.clickup.com/t/" + this.props.task_id) }}
              disabled={this.isCRMButtonDisabled}
              style={{
                marginBottom: '5px'
              }}
            />

            <Button
              text={"הורדת מסמך"}
              icon="fas fa-download"
              onClick={() => { this.downloadFile(this.props.attachmentLink) }}
              onPointerLeave={() => this.setState({ hovered: false })}
              disabled={this.isDownloadButtonDisabled}
              style={{
                marginBottom: '5px'
              }}
            />
            <Button
              text={"רענון תצוגה"}
              icon="fas fa-redo-alt"
              onClick={() => {
                this.props.refreshData();
                this.setState({ hovered: false })
              }}
              style={{
                marginBottom: '5px'
              }}
            />

          </div>
        </div>

        <h6 className={"signers"} style={{ marginBottom: '0px', marginTop: '12px', textAlign: 'center' }}>חתימות 📝</h6>
        <div className={"content-block dx-card responsive-paddings signers"} style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }} >

          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', flexWrap: 'wrap' }}>


            {this.createSignersList()}

          </div>

        </div>
      </div>
    );
  }
}

export default SignersList;